import { createContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {



    const navigate = useNavigate(); // Objeto Navegador para a navegação entre páginas
    const location = useLocation(); // Objeto Localização que saber em qual página o usuário está
    const [user, setUser] = useState(null); // Estado que armazena o Objeto Usuário
    const [isOpen, setIsOpen] = useState(false); // Contexto que armazena se a Sidebar está aberta ou não
    const [isEnabledLinks, setIsEnabledLinks] = useState(false); // Estado que armazena se os Links estão disponíveis para clique ou não
    const [modeTouch, setModeTouch] = useState(false); // Estado que armazena se a Sideber está atuando em modo touchscreen ou não
    const [showText, setShowText] = useState(false); // Estado que armazena se os Textos da Sidebar estão sendo exibidos ou não


    const [dashboardOpen, setDashboardOpen] = useState(false);
    const [empresasOpen, setEmpresasOpen] = useState(false);
    const [usuariosOpen, setUsuariosOpen] = useState(false);
    const [leadsOpen, setLeadsOpen] = useState(false); // Estado que armazena se o submenu Leads está aberto ou não
    const [produtosOpen, setProdutosOpen] = useState(false); // Estado que armazena se o submenu Produtos está aberto ou não
    const [relatoriosOpen, setRelatoriosOpen] = useState(false); // Estado que armazena se o submenu Relatorios está aberto ou não
    const [whatsappOpen, setWhatsappOpen] = useState(false); // Estado que armazena se o submenu WhatsApp está aberto ou não
    const [instagramOpen, setInstagramOpen] = useState(false); // Estado que armazena se o submenu Instagram está aberto ou não
    const [trackingOpen, setTrackingOpen] = useState(false); // Estado que armazena se o submenu Tracking está aberto ou não
    const [adsOpen, setAdsOpen] = useState(false); // submenu Tráfego Pago (BI de anúncios)


    return (
        <SidebarContext.Provider value={{
            navigate, location, user, setUser, isOpen, setIsOpen, isEnabledLinks, setIsEnabledLinks, modeTouch, setModeTouch, showText, setShowText,
            dashboardOpen, setDashboardOpen, empresasOpen, setEmpresasOpen, usuariosOpen, setUsuariosOpen, leadsOpen, setLeadsOpen, produtosOpen, setProdutosOpen,
            relatoriosOpen, setRelatoriosOpen,
            whatsappOpen, setWhatsappOpen,
            instagramOpen, setInstagramOpen,
            trackingOpen, setTrackingOpen,
            adsOpen, setAdsOpen
        }}>
            {children}
        </SidebarContext.Provider>
    );
};